import { UserTags } from '~/partials/Tags';
import { getRouteApi } from '@tanstack/react-router';
import { ScrollArea } from '~/primitives/scroll-area';

const Route = getRouteApi('/');
const roleOrder = [
    'Leader',
    'Developer',
    'Head Moderator',
    'Moderator',
    'Helper',
    'AREDL+',
];

function Editors() {
    const editorsData = Route.useLoaderData();
    const sortedEditorsData = editorsData
        ? editorsData.sort(
              (a, b) =>
                  roleOrder.indexOf(a.role_desc) -
                  roleOrder.indexOf(b.role_desc),
          )
        : [];

    return (
        <div className="flex flex-col items-center gap-4">
            <section className="p-4 rounded-xl w-full bg-background-darker">
                <h2 className="m-2 text-center">LIST EDITORS</h2>
                <>
                    {sortedEditorsData.map((role) =>
                        role.role_desc !== 'AREDL+' ? (
                            <div className="mb-3 text-center" key={role.id}>
                                <h3 className="mb-2 text-lg font-semibold">
                                    {role.role_desc}s
                                </h3>
                                <div className="flex flex-wrap justify-center gap-1 ">
                                    {role.users
                                        ?.sort((a, b) =>
                                            a.global_name.localeCompare(
                                                b.global_name,
                                            ),
                                        )
                                        .map((editor) => (
                                            <div
                                                className="flex items-center mb-1 p-1 rounded-md text-base bg-background-light hover:bg-primary hover:[&_p]:text-primary-foreground transition-colors"
                                                key={editor.id}
                                            >
                                                <img
                                                    src={`/assets/staff-icons/${role.role_desc}.svg`}
                                                    alt={role.role_desc}
                                                    className="w-4 h-4 mr-1"
                                                />
                                                <UserTags
                                                    item={editor}
                                                    className="text-secondary-light bg-transparent border-none hover:bg-transparent"
                                                />
                                            </div>
                                        ))}
                                </div>
                            </div>
                        ) : null,
                    )}
                </>
            </section>

            {sortedEditorsData.some((role) => role.role_desc === 'AREDL+') && (
                <section className="p-4 rounded-xl w-full bg-background-darker">
                    <h2 className="m-4 text-center">SUPPORTERS</h2>
                    <ScrollArea className="mb-3 h-[52vh] w-full overflow-x-hidden">
                        <div className="flex flex-wrap justify-center gap-1 ">
                            {sortedEditorsData
                                .find((role) => role.role_desc === 'AREDL+')
                                ?.users.map((supporter) => (
                                    <div
                                        className="flex items-center mb-1 p-1 rounded-md text-base bg-background-light hover:bg-primary hover:[&_p]:text-secondary-foreground transition-colors"
                                        key={supporter.id}
                                    >
                                        <img
                                            src={`/assets/staff-icons/AREDL+.svg`}
                                            alt="Supporter"
                                            className="w-4 h-4 mr-1"
                                        />
                                        <UserTags
                                            item={supporter}
                                            className="text-secondary-light bg-transparent border-none hover:bg-transparent"
                                        />
                                    </div>
                                ))}
                        </div>
                    </ScrollArea>
                </section>
            )}
        </div>
    );
}

export default Editors;
